module.exports = __webpack_public_path__ + "605730bd0e37407cec6560c8a832672e.jpg";